import React from "react";

import { bem } from "ComparePlans/styles";
import isIntuit from "Intuit/isIntuit";
import { sortBy } from "lodash";
import simplifyPlanName from "Utils/simplifyPlanName";

import BodyText from "Common/BodyText";
import { Card } from "Common/Card";
import { CarrierLogoFlexbox } from "Common/CarrierLogo";
import { Grid } from "Common/Grid";
import { ContentRow } from "Common/Table";

import EstimatedCosts from "./Components/EstimatedCosts";
import MoreDetails from "./Components/MoreDetails";
import Overview from "./Components/Overview";

import type { MedicalPlanPrice } from "Utils/types";

export const Page = React.forwardRef(
  ({ plans, planButtons, isSampleQuote, topHeading, topCell, shouldShowSimplePlanName, isInRenewal, planDeviationProps }, ref) => {
    const sortedPlans: Array<MedicalPlanPrice> = sortBy(plans, (plan) => (plan ? plan.total_cost : Number.MAX_VALUE));

    if (sortedPlans.length === 0) {
      return <Grid componentClass={Card}>No plans to show</Grid>;
    }
    const planGrid = (
      <Grid className={`${bem("Header")}`} pt={3} pb={3}>
        <table id="compare-header-table" className={bem("PageHeader")}>
          <tbody>
            {topCell && <ContentRow heading={topHeading} cell={topCell} items={sortedPlans} />}

            <ContentRow
              heading={topCell ? undefined : topHeading}
              cell={(p) => [
                <CarrierLogoFlexbox key="carrierLogo" plan={p} maxSize={2} />,
                <div key="name" className={bem("PlanName")} title={p.raw_name}>
                  <BodyText size="large" weight={isIntuit() ? "bold" : null} className={bem("PlanText")}>
                    {shouldShowSimplePlanName ? simplifyPlanName(p) : p.display_name}
                  </BodyText>
                </div>,
              ]}
              items={sortedPlans}
            />
          </tbody>
        </table>
      </Grid>
    );

    return (
      <div ref={ref}>
        {planGrid}
        <Grid id="compare-plans-page" className={bem("Page")}>
          <table id="quote" className={bem("PageBody")}>
            <Overview plans={sortedPlans} planButtons={planButtons} isSampleQuote={isSampleQuote} isInRenewal={isInRenewal} />

            <EstimatedCosts plans={sortedPlans} planDeviationProps={planDeviationProps} />

            <MoreDetails plans={sortedPlans} />
          </table>
        </Grid>
      </div>
    );
  },
);
